var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconNotificationWhite = function SvgIconNotificationWhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44,
    height: 44,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    fill: "#fff",
    fillOpacity: 0.2,
    rx: 22
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#icon-notification-white_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M28.452 24.648v-3.8c0-2.822-1.807-5.283-4.294-6.203a2.204 2.204 0 1 0-4.32-.013 6.4 6.4 0 0 0-2.318 1.436 6.4 6.4 0 0 0-1.971 4.642v3.938a.255.255 0 0 1-.255.255c-1.19 0-2.207.897-2.316 2.039a2.26 2.26 0 0 0 2.248 2.477h3.89A2.91 2.91 0 0 0 22 32a2.91 2.91 0 0 0 2.884-2.58h3.89c.636 0 1.246-.272 1.671-.74a2.29 2.29 0 0 0 .578-1.738c-.11-1.142-1.129-2.039-2.316-2.039a.253.253 0 0 1-.255-.255M22 13.29c.504 0 .913.41.913.913 0 .042-.006.08-.013.123a6 6 0 0 0-.664-.062 6.7 6.7 0 0 0-1.136.065c-.006-.042-.013-.08-.013-.123 0-.506.41-.916.913-.916m0 17.42a1.62 1.62 0 0 1-1.58-1.29h3.161a1.62 1.62 0 0 1-1.58 1.29m7.74-3.646a.97.97 0 0 1-.246.749.97.97 0 0 1-.72.316H15.227a.96.96 0 0 1-.716-.316.96.96 0 0 1-.248-.748c.045-.488.5-.871 1.032-.871.851 0 1.545-.694 1.545-1.546V20.71a5.12 5.12 0 0 1 1.578-3.713 5.11 5.11 0 0 1 3.774-1.445c2.738.096 4.97 2.474 4.97 5.296v3.8c0 .852.694 1.546 1.546 1.546.532 0 .984.383 1.032.87"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "icon-notification-white_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M12 12h20v20H12z"
  })))));
};
export default SvgIconNotificationWhite;